/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Search = props => (
  <svg width="16px" height="16px" viewBox="0 0 16 16">
    <g id="Dark-version" stroke="none" strokeWidth="1" fill="none">
      <g
        id="01-Dashboard-B"
        transform="translate(-452.000000, -33.000000)"
        fill="#5D6164"
      >
        <g id="Top">
          <g id="Search" transform="translate(243.000000, 22.000000)">
            <path
              d="M224.19,22.26 L221.62,19.69 C221.87,19.01 222,18.27 222,17.5 C222,13.91 219.09,11 215.5,11 C211.91,11 209,13.91 209,17.5 C209,21.09 211.91,24 215.5,24 C216.27,24 217.01,23.87 217.69,23.62 L220.259,26.19 C220.78,26.71 221.48,27 222.22,27 C222.96,27 223.66,26.71 224.191,26.19 C225.27,25.1 225.27,23.34 224.19,22.26 L224.19,22.26 Z M216.04,21.97 C215.86,21.99 215.68,22 215.5,22 C213.02,22 211,19.98 211,17.5 C211,15.02 213.02,13 215.5,13 C217.98,13 220,15.02 220,17.5 C220,17.68 219.99,17.86 219.97,18.04 C219.88,18.79 219.6,19.49 219.18,20.08 C218.88,20.51 218.51,20.88 218.08,21.18 C217.49,21.6 216.79,21.88 216.04,21.97 L216.04,21.97 Z M222.77,24.77 C222.481,25.071 221.96,25.071 221.67,24.77 L219.51,22.611 C219.92,22.291 220.29,21.921 220.611,21.51 L222.77,23.67 C223.08,23.98 223.08,24.47 222.77,24.77 L222.77,24.77 Z"
              id="Seach-icon"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default extendIcon(Search);
